import React from 'react';
import "./onboarding.scss";
import { Constants, ImageConstants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source'
import Path from '../routes/routes-path';

class Onboarding extends React.Component {

    state = {
        activeTabIndex: 0,
        classDropdownData: null,
        sectionDropdownData: null,
        schoolDropdownData: null,
        isSignUpfailed: false,
        isEmailAlreadyRegistered: false,
        isLoginFailed: false,
        loading: false,
        signUpEmail: null
    }

    tabs = [
        { name: 'Login' },
    ];


    componentDidMount() {
    }

    onCLickContinue = () => {
        this.props.history.replace(Path.UPDATE_PASSWORD)
    }


    render() {

        return (
            <div className="container-fluid onboarding" >
                <div className='header row no-gutters'>
                    <div className="col-6"> <img alt="" className="logo" src={getImageSource(ImageConstants.CW_LOGO)} /></div>
                </div>

                <div className="onboard-wrapper">
                    <div className='row'>
                        <div className="col content-left">
                            <div>
                                <p className='slogan-text'>Welcome to Countingwell</p>
                                <p className="description">Countingwell makes Maths learning fun with step-by-step personlized learning path.</p>
                            </div>
                            <div className="pt-5">
                                <div className="row pt-1 text-center">
                                    <div className="col">
                                        <img alt="" className="description-image" src={getImageSource(ImageConstants.STUDENTS)} />
                                        <div className="pt-5">
                                            <div className="count">10000+</div>
                                            <div className="count-title pt-2">Active Students</div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <img alt="" className="description-image" src={getImageSource(ImageConstants.VIDEOS)} />
                                        <div className="pt-5">
                                            <div className="count">800+</div>
                                            <div className="count-title  pt-2">Learning Videos</div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <img alt="" className="exam-pad" src={getImageSource(ImageConstants.EXAM_PAD)} />
                                        <div className="pt-5">
                                            <div className="count">1000+</div>
                                            <div className="count-title pt-2">Practice Questions</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row quote">
                                <div className="col-1">
                                    <img className="quote-image" src={getImageSource(ImageConstants.QUOTE_LEFT)} />
                                </div>
                                <div className="col-11">
                                    <div className=" quote-text">
                                        I am enjoying the app. Beside I am also learning. Now I
                                        am thinking if countingwell app was not there I would be
                                        bored.
                                    </div>

                                    <div className="author pt-4">Bidhyanshu Das, Class 7 Student from Kolkata</div>
                                </div>
                                <div className="col text-right">
                                    <img className="quote-image" src={getImageSource(ImageConstants.QUOTE_RIGHT)} />
                                </div>
                            </div>
                        </div>
                        <div className="col content-right">
                            <div className="video-wrapper ">
                                <video className="video-content" width="600" controls autoPlay>
                                    <source src={"https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/13eb1263-6c57-458c-a84e-7291d654bb92_NEP%20Aligned%20Maths%20Learning%20for%20School.mp4"} type="video/mp4" />
                                </video>
                                <div className="description pt-4">
                                    Play this video for a quick look at how Countingwell works and makes Maths learning effective and easy for you.
                                </div>
                            </div>

                            <div className="countinue-button text-center cursor-pointer" onClick={this.onCLickContinue.bind(this)}>
                                <span>CONTINUE</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Onboarding;